import { NgModule } from '@angular/core';
import { GrdFilterPipe } from './grd-filter.pipe';

@NgModule({
    declarations: [GrdFilterPipe],
    exports: [ GrdFilterPipe]
  })

export class MyPipesModule{}
